import { InfoName } from './score-disclosuere.types';

export const getTrackName = (iName: InfoName) => {
  switch (iName) {
    case 'company_name':
      return 'Company Name';
    case 'business_address':
      return 'Business Address';
    case 'target_audience':
      return 'Target Audience';
    case 'geographic_focus':
      return 'Geographic Focus';
    case 'robots_txt_permissions':
      return 'Robots.txt Crawler Permissions';
    case 'llms_txt_configuration':
      return 'LLMs.txt Configuration';
    case 'structured_data':
      return 'Structured Data';
    case 'server_side_rendering':
      return 'Server-Side Rendering';
    case 'product_name':
      return 'Product Name';
    default:
      return '';
  }
};

export const getRuleTrackName = (rName: string) => {
  switch (rName) {
    case 'conversational_content_writing':
      return 'Conversational Content Writing';
    case 'statistical_evidence_integration':
      return 'Statistical Evidence Integration';
    case 'content_freshness_indicators':
      return 'Content Freshness Indicators';

    case 'llm_implementation':
      return 'LLMs.txt Implementation';
    case 'js_crawlability':
      return 'JavaScript Crawlability';
    case 'speed_of_load':
      return 'Speed of Load';
    case 'core_web_vitals':
      return 'Core Web Vitals';

    case 'entity_disambiguation':
      return 'Entity Disambiguation';
    case 'contextual_association':
      return 'Contextual Association';
    case 'basic_consistency':
      return 'Basic Consistency';
    case 'schema_readiness':
      return 'Schema Readiness';

    case 'address_completeness_accuracy':
      return 'Address Completeness';
    case 'contact_integration':
      return 'Contact Integration';
    case 'consistency_presentation':
      return 'Consistency';

    case 'presentation_quality':
      return 'Presentation Quality';
    case 'consistency_across_pages':
      return 'Consistency';
    case 'specificity':
      return 'Specificity';
    case 'llm_citation_potential':
      return 'LLM Citation Potential';

    case 'service_delivery_evidence':
      return 'Service Delivery Evidence';
    case 'specificity_for_ai_citation':
      return 'Specificity for AI Citation';
    case 'evidence_consistency':
      return 'Evidence Consistency';

    default:
      return undefined;
  }
};
